// Angular
import { Component, Input, OnInit, OnDestroy } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { DatabaseService } from '../../../../../core/_services/database.service';
import { TaskQueue } from '../../../../../core/_shared/models/task-queue.model';
import { EnumHelper } from '../../../../../core/_shared/utils/enum-helper';
import { BetTaskTypes } from '../../../../../core/_shared/models/BetTaskTypes';

@Component({
	selector: 'app-finished-task',
	templateUrl: './finished-task.component.html',
	styleUrls: ['finished-task.component.scss']
})
export class FinishedTaskComponent implements OnInit, OnDestroy {

	public active = "1";

	unsubscribleTasks: () => void;

	// Show dot on top of the icon
	@Input() dot: string;

	// Show pulse on icon
	@Input() pulse: boolean;

	@Input() pulseLight: boolean;

	// Set icon class name
	@Input() icon = 'flaticon2-bell-alarm-symbol';
	//@Input() icon = 'computer';
	@Input() iconType: '' | 'success';

	// Set true to icon as SVG or false as icon class
	@Input() useSVG: boolean;

	// Set bg image path
	@Input() bgImage: string;

	// Set skin color, default to light
	@Input() skin: 'light' | 'dark' | 'lilac' = 'light';

	@Input() type: 'brand' | 'success' = 'success';
	activeProcesses: number = 0;
	public tasks: TaskQueue[] = [];
	notVisualized: number;

	/**
	 * Component constructor
	 *
	 * @param sanitizer: DomSanitizer
	 */
	constructor(private sanitizer: DomSanitizer,
		private _database: DatabaseService) {
	}

	backGroundStyle(): string {
		if (!this.bgImage) {
			return 'none';
		}

		return 'url(' + this.bgImage + ')';
	}

	ngOnInit(): void {


		this.unsubscribleTasks = this._database.getCurrentCustomer()
			.getFinishedTasks().getCollection()
			.orderBy("createDate", "desc")
			.onSnapshot(queySnapshot => {
				
				let notVisualized = 0;
				this.activeProcesses = 0;
				this.tasks = [];
				//console.log("Tarefas finalizadas atualizando gui: ", queySnapshot.size);
				queySnapshot.forEach(snapshot => {
					this.activeProcesses++;

					let obj = Object.assign(snapshot.data());
					obj.cryptoBetId = btoa(obj.BetId);

					if (obj.visualized != true) {
						notVisualized++;
						// console.log("Atualizando na gui: ", obj.id);
						// console.log( obj);
						if (obj.visualized == null) {

							//Corrigir o campo de visualização quando por algum bug ele não existe
							this._database.getCurrentCustomer()
								.getFinishedTasks().getTask(obj.id)
								.getDocument().setFields({ visualized: false }).then();
						}
					}

					if (obj.ownerTask != null) {
						obj.machineId = obj.ownerTask.machineId;
						obj.taskTypeName = EnumHelper.GetDescription(BetTaskTypes, obj.ownerTask.taskType);
					}
					this.tasks.push(obj);

				});

			//	console.log("notVisualized: ", notVisualized);
				this.notVisualized = notVisualized;

				this.pulse = true;

				setTimeout(() => {
					this.pulse = false;
				}, 5000);
			},null,null,50);
	}


	ngOnDestroy(): void {
		this.unsubscribleAll();
	}

	unsubscribleAll(): void {

		if (this.unsubscribleTasks != null) {
			this.unsubscribleTasks();
		}

	}

	public showProcessedNotifications() {

		this._database.getCurrentCustomer()
			.getFinishedTasks().getCollection().where("visualized", "==", false)
			.get()
			.then(snapshotQuery => {

				snapshotQuery.forEach(snapshot => {
					let data = snapshot.data();
					data.visualized = true;

					this._database.getCurrentCustomer()
						.getFinishedTasks().getCollection().doc(snapshot.id)
						.set(data).then();

				});
			});


	}

}
